/** The type of a download link click */
export const LinkDownloadType = ["text", "button", "image"] as const;
export type LinkDownloadType = (typeof LinkDownloadType)[number];